import { animated, useSpring } from '@react-spring/web'
import React from "react";

const Step = ({ index, length, activeStep, onClick, children, style }) => {
    const spring = useSpring({
        backgroundColor: activeStep === length - 1 && activeStep === index ? "green" : index < activeStep ? "#003854" : index === activeStep ? "#ef4136" : "#f4f4f4",
    })

    return (
        <animated.div
            onClick={onClick}
            className={`absolute -translate-y-1/2 rounded-full h-7 w-7 flex items-center justify-center ${index === length - 1 ? "-translate-x-full" : index !== 0 ? "-translate-x-1/2" : ""} ${index <= activeStep ? "bg-skgBlue" : "#f4f4f4"}`}
            style={{
                left: 100 / (length - 1) * index + "%",
                ...spring,
                ...style
            }}
        >
            {
                React.cloneElement(children, { color: "white" })
            }
        </animated.div>
    )
}

const StepLine = ({ steps, activeStep, goTo }) => {
    const spring = useSpring({
        from: {
            width: "0%"
        },
        to: {
            width: steps && activeStep ? `${100 / (steps.length - 1) * activeStep}%` : "0%"
        }
    })

    const widthSpring = useSpring({
        from: {
            maxWidth: activeStep === steps.length - 1 ? 100 : 958,
            display: "block",
        },
        to: [
            {
                maxWidth: activeStep === steps.length - 1 ? 200 : 958,
                opacity: activeStep === steps.length - 1 ? 0 : 1
            },
            { display: activeStep === steps.length - 1 ? "none" : "block" }
        ]
    })

    const opacitySpring = useSpring({
        opacity: activeStep === steps.length - 1 ? 0 : 1
    })

    return (
        <>
            <animated.div
                className="relative mb-10 mt-3"
                style={widthSpring}
            >
                <div
                    className="h-0.5 bg-gray-200"
                >
                    <animated.div
                        className="bg-skgBlue h-full"
                        style={{
                            ...spring,
                            ...opacitySpring
                        }}
                    />
                    {
                        steps.map(({ icon }, i) => {
                            return (
                                <Step
                                    key={i}
                                    style={opacitySpring}
                                    index={i}
                                    length={steps.length}
                                    activeStep={activeStep}
                                    onClick={() => {
                                        if (activeStep >= i && activeStep !== steps.length - 1) {
                                            goTo(i)
                                        }
                                    }}
                                >
                                    {icon}
                                </Step>
                            )
                        })
                    }
                </div>
            </animated.div>
        </>
    )
}

export default StepLine;


